import { createRefreshScheduler } from "./refresh-scheduler";

const opts = { debounceMs: 500, minIntervalMs: 1400 } as const;

let rawRefresh: (() => void) | undefined;
let scheduler: ReturnType<typeof createRefreshScheduler> | undefined;

/**
 * Registers `router.refresh` from a client subtree (typically once under `(main)`).
 * Call `unregisterRouterRefresh` on cleanup.
 */
export function registerRouterRefresh(refresh: () => void) {
	rawRefresh = refresh;
	scheduler?.cancel();
	scheduler = createRefreshScheduler(refresh, opts);
}

export function unregisterRouterRefresh() {
	scheduler?.cancel();
	scheduler = undefined;
	rawRefresh = undefined;
}

/**
 * Coalesced soft RSC refresh — use after mutations and realtime hints so bursts
 * do not refetch the whole tree on every event.
 */
export function scheduleRouterRefresh() {
	scheduler?.schedule();
}

/** Bypass debounce (e.g. explicit user “reload” control). */
export function flushRouterRefresh() {
	rawRefresh?.();
}
